import React, { useState } from 'react'
import { hasValidation, shouldDisable, shouldHide } from '../../../services/ValidationService'
import { FieldProperties } from '../../types'

/* eslint-disable @typescript-eslint/no-unused-vars */
export const EmailField = (properties: FieldProperties): React.ReactElement<FieldProperties> => {
    const [formMode, setFormMode] = useState(properties.formMode)

    const renderTableView = (): React.ReactElement => {
        return (
            <>
                {properties.data.valid && (
                    <>
                        <a href={String('mailto: ') + properties.data.address}>
                            <i className="px-2 fa-solid fa-envelope"></i>
                        </a>
                    </>
                )}
                {!properties.data.valid && (
                    <>
                        <i className="px-2 fa-solid fa-envelope"></i>
                    </>
                )}
            </>
        )
    }

    const renderFormView = (): React.ReactElement => {
        let hideField = shouldHide(formMode, properties.fieldConfig)
        /* eslint-disable @typescript-eslint/no-unused-vars */
        const disableField: boolean = shouldDisable(formMode, properties.fieldConfig)
        /* eslint-disable @typescript-eslint/no-unused-vars */
        const required = hasValidation(properties.fieldConfig?.validators)

        hideField = true // hide it
        return (
            <>
                {!hideField && (
                    <a href={properties.data.address}>
                        <i className="px-2 fa-solid fa-envelope"></i>
                    </a>
                )}
            </>
        )
    }

    return <>{properties.isTableView ? renderTableView() : renderFormView()}</>
}
